import React, { useState } from 'react';
import { Modal, Button, Form, Alert, Spinner } from 'react-bootstrap';
import api from '../../services/api';

const AssociationImportModal = ({ show, handleClose, onImportSuccess }) => {
  // State for file upload
  const [importFile, setImportFile] = useState(null);
  const [importLoading, setImportLoading] = useState(false);
  const [importError, setImportError] = useState(null);
  const [importSuccess, setImportSuccess] = useState(null);

  // Handle file change
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setImportFile(e.target.files[0]);
    }
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!importFile) {
      setImportError('Seleziona un file Excel da importare');
      return;
    }

    try {
      setImportLoading(true);
      setImportError(null);
      setImportSuccess(null);

      const formData = new FormData();
      formData.append('excelFile', importFile);

      const token = localStorage.getItem('token');
      const response = await api.post('/import/associations', formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      setImportSuccess(`${response.data.message}`);
      setImportLoading(false);

      // Call parent success handler if provided
      if (onImportSuccess) {
        onImportSuccess(response.data);
      }
    } catch (err) {
      console.error('Error importing associations:', err);
      setImportError(
        err.response?.data?.message ||
        'Errore durante l\'importazione. Verifica il formato del file.'
      );
      setImportLoading(false);
    }
  };

  // Handle modal close and reset state
  const handleModalClose = () => {
    setImportFile(null);
    setImportError(null);
    setImportSuccess(null);
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleModalClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Importa Associazioni</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Utilizzare questa funzione per importare le associazioni da un file Excel (formato .xlsx).
        </p>
        <p>
          Il file deve contenere i seguenti campi (ma non necessariamente in questo ordine):
        </p>
        <ul>
          <li><strong>Cod. aff.</strong> - Codice dell'affiliata</li>
          <li><strong>Ragione soc.</strong> - Nome dell'associazione</li>
          <li><strong>Email</strong> - Email dell'associazione</li>
          <li><strong>Telefono</strong> - Numero di telefono</li>
          <li><strong>Regionale</strong> - Comitato regionale di appartenenza</li>
          <li><strong>Provinciale</strong> - Comitato provinciale/territoriale</li>
        </ul>

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Seleziona file Excel</Form.Label>
            <Form.Control
              type="file"
              onChange={handleFileChange}
              accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            />
            <Form.Text className="text-muted">
              Accettati solo file Excel (.xlsx)
            </Form.Text>
          </Form.Group>

          {importError && (
            <Alert variant="danger" className="mt-3">
              {importError}
            </Alert>
          )}

          {importSuccess && (
            <Alert variant="success" className="mt-3">
              {importSuccess}
            </Alert>
          )}

          <div className="d-flex justify-content-end mt-4">
            <Button variant="secondary" onClick={handleModalClose} className="me-2">
              Chiudi
            </Button>
            <Button
              variant="primary"
              type="submit"
              disabled={!importFile || importLoading}
            >
              {importLoading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Importazione in corso...
                </>
              ) : (
                'Importa Associazioni'
              )}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AssociationImportModal;
